import gdsillustration from '../../assets/illustrations/google-data-studio-illustration.svg';
import getEmbeddedManifest from '../utils/embedded-manifest';

export const key = 'wixAnalytics';

export const integration = () =>
  getEmbeddedManifest({
    key,
    integrationConfig: {
      type: 'wixAnalytics',
      name: 'wixAnalytics',
      loadOnce: true,
      enabled: true,
    },
    dashboardWidget: {
      title: 'google-data-studio.widget.title',
      description: 'google-data-studio.widget.description',
    },
    detailsPage: {
      header: {
        title: 'google-data-studio.details-page.title',
        description: 'google-data-studio.details-page.subtitle',
        articleId: 'google-data-studio.details-page.articleId',
      },
      actions: {
        edit: {
          label: 'google-data-studio.details-page.cta.title',
          hideWhenComplete: true,
        },
      },
      status: {
        connectedTitle: 'google-data-studio.details-page.status.connected',
        disconnectedTitle:
          'google-data-studio.details-page.status.disconnected',
      },
    },
    modal: {
      type: 'notification',
      title: 'google-data-studio.modal.title',
      subtitle: 'google-data-studio.modal.subtitle',
      illustration: gdsillustration,
      close: 'google-data-studio.modal.cta',
    },
    requiredPermissions: ['my-account.manage-html-embeds'],
  });
